export { QuestDetailsPage as default } from 'components/quests/quest-details-page';
